































































































































import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import VpnReservedDetailBase from "./VpnReservedDetailBase";

@Component
export default class VpnReservedDetail extends VpnReservedDetailBase {

	created() {
		this.returnRoute = "VpnReservedList";
		super.initializeRights('COR_Setting_Global', 'COR_Setting_Global', 'COR_Setting_Global', 'COR_Setting_Global');
		super.setMainDescription('vpnReserved.new', 'vpnReserved.detail');
	}

	infoShortInput(value: string) {
		this.infoShortInputBase(value);
	}

	mounted() {
		this.fetchVpnBaseList();
		super.mounted();
	};

	validate() {
		return this.validateBase();
	}

	isCorrectName(value: any) {
		this.isCorrectNameBase(value);
	}

	isCorrectDescription(value: any) {
		this.isCorrectDescriptionBase(value);
	}

	isCorrectAddress(value: any) {
		this.isCorrectAddressBase(value);
	}

	isCorrectCidr(value: any) {
		this.isCorrectCidrBase(value);
	}
}

